import { render, staticRenderFns } from "./wxunion.vue?vue&type=template&id=594e58f7&"
import script from "./wxunion.vue?vue&type=script&lang=js&"
export * from "./wxunion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports